const tools = require('../../tools')
const { create: createAllocations } = require('../../allocations/api')

exports.getFacilityQTODataFromReports = getFacilityQTODataFromReports
async function getFacilityQTODataFromReports (
  state,
  mainApi,
  { locationId, programId, productIds, date, reportingPeriod } = {}
) {
  tools.validateParams('getFacilityQTODataFromReports', arguments[2])

  const [location, products] = await Promise.all([
    mainApi.location.get(locationId, date),
    mainApi.product.getByIds(productIds)
  ])

  const allocations = await createAllocations(state, {
    locations: [location],
    products,
    orders: [],
    programId,
    date,
    reportingPeriod,
    doNotFilterPrograms: true
  })

  return allocations[0] || {
    location,
    products: {},
    reports: []
  }
}
